import { ViewEncapsulation, Component, Input, OnInit } from '@angular/core';
import { buildNumber } from 'src/main/webapp/assets/buildnumber';
import { environment } from 'src/main/webapp/environments/environment';
import { RestTmtService } from '../../rest-tmt.service';
/**ToDo Documentazione */
@Component({
  selector: 'app-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  public appVersion = '';
  public htmlContent: string | undefined;
  public isHtmlContent: any;

  constructor(public readonly service: RestTmtService) { }

  @Input() public version: any = 'GAS';

  public ngOnInit(): void {
    this.loadHtmlContent();
    this.appVersion = this.getVersion();
  }

  public getVersion(): string {
    const versionNumber = environment.app_version;

    return `${versionNumber} (Build ${buildNumber.build})`;
  }

  loadHtmlContent() {
    this.service.getFooter(this.version)
      .subscribe((data: string) => {
        const cleanedContent = data
          .replace(/\s/g, '')
          .replace(/<[^>]*><\/[^>]*>/g, '')
          .replace(/<!--.*?-->/g, '');
        
        this.isHtmlContent = cleanedContent.length;
        this.htmlContent = data;
      });
  }
}
